export default __webpack_public_path__ + "static/media/1574.eda08483.png";